import { createContext, useContext } from "react"

type BuilderSaveContextValue = { flush: () => Promise<void> }

export const BuilderSaveContext = createContext<BuilderSaveContextValue | undefined>(undefined)

export function useBuilderSaveContext() {
  const ctx = useContext(BuilderSaveContext)
  if (!ctx) throw new Error("useBuilderSaveContext must be used within a BuilderProvider")
  return ctx
}
